module.exports = __webpack_public_path__ + "img/landing.067eb157.jpg";